import {MarketMoverRecord} from "../types/MarketMoversState";
import {Exchange} from "../../../instruments/exchange/Exchange";
import {PriceStrategy} from "../../../components/inputs/price/input/PriceStrategy";

export interface MarketMoversStateModel {
    readonly top200: MarketMoversModel;
    readonly all: MarketMoversModel;
}

export interface MarketMoversModel {
    readonly gainers: MarketMoverModels;
    readonly losers: MarketMoverModels;
}

export type MarketMoverModels = ReadonlyArray<MarketMoverModel>;

export class MarketMoverModel implements MarketMoverRecord {

    private constructor(private readonly record: MarketMoverRecord,
                        public readonly priceStrategy: PriceStrategy) {
    }

    public get code(): string {
        return this.record.code;
    }

    public get exchange(): Exchange {
        return this.record.exchange;
    }

    public get change(): number {
        return this.record.change;
    }

    public get changePercent(): number {
        return this.record.changePercent;
    }

    public get last(): number {
        return this.record.last;
    }

    public static of(record: MarketMoverRecord, strategy: PriceStrategy): MarketMoverModel {
        return new MarketMoverModel(record, strategy);
    }
}
